var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4246 24.2099C45.6541 23.9189 45.7669 23.5532 45.7411 23.184C45.7153 22.8147 45.5527 22.4682 45.2849 22.2116C45.0171 21.9551 44.6631 21.8068 44.2917 21.7956C43.9204 21.7844 43.558 21.911 43.2751 22.1509L16.4066 44.9235L2.21792 39.4569C1.6007 39.2215 1.06426 38.8146 0.672363 38.2845C0.280461 37.7544 0.049571 37.1233 0.00712708 36.4663C-0.0353169 35.8093 0.11247 35.1539 0.432928 34.5781C0.753386 34.0023 1.23304 33.5303 1.8149 33.2181L60.719 0.346012C61.1819 0.0975812 61.7039 -0.020961 62.2292 0.00303805C62.7544 0.0270371 63.2633 0.192677 63.7015 0.482278C64.1397 0.771879 64.4907 1.17457 64.7171 1.64738C64.9435 2.12019 65.0367 2.64536 64.9869 3.16685L59.8199 56.8246C59.7682 57.3749 59.5882 57.9056 59.2944 58.3745C59.0005 58.8433 58.6009 59.2374 58.1272 59.5253C57.6536 59.8132 57.119 59.987 56.5661 60.0329C56.0132 60.0788 55.4572 59.9955 54.9423 59.7896L37.674 53.1287L26.8336 63.2487C26.4335 63.6211 25.9327 63.8685 25.3929 63.9602C24.8532 64.052 24.2983 63.9841 23.7969 63.765C23.2955 63.546 22.8695 63.1852 22.5717 62.7275C22.2739 62.2698 22.1173 61.7351 22.1213 61.1897V53.2419L45.4246 24.2099Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.db28897490a3f49096d8b13f732ae8f9.svg";
export { ForwardRef as ReactComponent };